export const name = 'NetworkConnectivityException';

export default class NetworkConnectivityException extends Error {
  constructor(message) {
    super(message); // (1)
    this.name = name;
  }
}
